import type {PunishmentDetailSerializer, PunishmentSerializer} from "@/generated/DjangoTypes";
import type {TPunishmentType} from "@/store/types";
import dayjs from "dayjs";

const HOURS_IN_DAY = 24;
const MINUTES_IN_HOUR = 60;

export const isDisciplineActive = (discipline: PunishmentDetailSerializer | PunishmentSerializer) =>
  dayjs().isBetween(dayjs(discipline.effective_date), dayjs(discipline.expiration_date)) ||
  isDisciplineOngoing(discipline);

export const isDisciplineOngoing = (discipline: PunishmentDetailSerializer | PunishmentSerializer) => {
  const {punishment_type, expiration_date} = discipline;

  const isOngoingType =
    isUnverifiedType(punishment_type) ||
    (punishment_type === "PROBATION" && !expiration_date) ||
    punishment_type === "PERMANENT_BAN";

  const isNotExpired = !expiration_date || dayjs().isBefore(dayjs(expiration_date));

  return isOngoingType && isNotExpired;
};

export const isUnverifiedType = (type: TPunishmentType) =>
  type === "UN_VERIFIED_INSTAGRAM" || type === "UN_VERIFIED_TIKTOK" || type === "UN_VERIFIED_UGC";

export const getDisciplineColor = (disciplineType: TPunishmentType | "GENERAL_UNVERIFIED") => {
  switch (disciplineType) {
    case "PERMANENT_BAN":
      return "danger-crimson";
    case "PROBATION":
      return "warning-medium-yellow";
    case "TIMED_BAN":
      return "danger-medium-red";
    default:
      return "danger-raspberry";
  }
};

export const getRemainingTime = (expiration_date?: string | null) => {
  if (!expiration_date) {
    return {remainingDays: 0, remainingHours: 0, remainingMinutes: 0};
  }

  const totalMinutes = dayjs(expiration_date).diff(dayjs(), "minute");
  const remainingDays = Math.floor(totalMinutes / (MINUTES_IN_HOUR * HOURS_IN_DAY));
  const remainingHours = Math.floor((totalMinutes % (MINUTES_IN_HOUR * HOURS_IN_DAY)) / MINUTES_IN_HOUR);
  const remainingMinutes = totalMinutes % MINUTES_IN_HOUR;

  return {remainingDays, remainingHours, remainingMinutes};
};
